/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { h } from "@stencil/core";
import { InteractiveContainer } from "../../utils/interactive";
import { CSS, SLOTS } from "./resources";
export const List = ({ props: { disabled, loading, filterEnabled, dataForFilter, handleFilterEvent, filterPlaceholder, filterText, setFilterEl, dragEnabled, storeAssistiveEl, }, }) => {
    const defaultSlot = h("slot", null);
    return (h(InteractiveContainer, { disabled: disabled }, h("section", null, dragEnabled ? (h("span", { "aria-live": "assertive", class: "assistive-text", ref: storeAssistiveEl })) : null, h("header", { class: { [CSS.sticky]: true } }, filterEnabled ? (h("calcite-filter", { "aria-label": filterPlaceholder, disabled: disabled, items: dataForFilter, onCalciteFilterChange: handleFilterEvent, placeholder: filterPlaceholder, ref: setFilterEl, value: filterText })) : null, h("slot", { name: SLOTS.menuActions })), loading ? h("calcite-scrim", { loading: loading }) : null, defaultSlot)));
};
export default List;
//# sourceMappingURL=shared-list-render.js.map
